import React from 'react';
import { useLocation } from "react-router-dom";
import { useForm } from 'react-hook-form';

// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Row,
    Col,
    Form,
    FormGroup,
    Input
} from "reactstrap";


// services
import { showMessage } from "../../services/message.js";
import { InputTELEFONE } from "../../services/mask.js";
import { api_PUT } from "../../services/api_service.js";

//helpers
import { ValidaEmail } from "../../helpers/email";

//Context
import { useAuth } from '../../context/auth';


export default function AtualizarContato({ history }) {
    const { setLoading } = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const location = useLocation();

    const [step, set_step] = React.useState(0);

    const loadDefaultValues = (field) => {
        var item = location.state.protocolo;

        if (item == null)
            return "";

        if (item.segmentoProtocolo == 'Grande Gerador' || item.segmentoProtocolo == 'Gerador') {
            switch (field) {
                case "Telefone": return item.protocoloGerador.length > 0 ? item.protocoloGerador[0].telefone : "";
                case "Celular": return item.protocoloGerador.length > 0 ? item.protocoloGerador[0].celular : "";
                case "Email": return item.email ? item.email : "";
            }
        }

        if (item.segmentoProtocolo == 'Transportador') {
            switch (field) {
                case "Telefone": return item.protocoloTransportador.length > 0 ? item.protocoloTransportador[0].telefone : "";
                case "Celular": return item.protocoloTransportador.length > 0 ? item.protocoloTransportador[0].celular : "";
                case "Email": return item.email ? item.email : "";
            }
        }

        if (item.segmentoProtocolo == 'Destino Final') {
            switch (field) {
                case "Telefone": return item.protocoloDestino.length > 0 ? item.protocoloDestino[0].telefone : "";
                case "Celular": return item.protocoloDestino.length > 0 ? item.protocoloDestino[0].celular : "";
                case "Email": return item.email ? item.email : "";
            }
        }

    }
    // E-Mail
    const [email, set_email] = React.useState(location.state.protocolo.email);
    const handleEmail = (event) => {

        if (event.target.value.length == 0)
            return;

        set_email(event.target.value);

        ValidaEmail(event.target.value, handleRetornoValidaEmail);
    }
    const handleRetornoValidaEmail = (result) => {
        if (!result.data) {
            showMessage("Aviso", "E-mail inválido.", 'error', null);
            setValue("email", "");
            set_email("");
        }
    }


    const onSubmit = (data) => {
        setLoading(true);
        let item = location.state.protocolo;
        let controller = '';

        if (email == null || email.length == 0) {
            setLoading(false);
            showMessage("Aviso", "E-mail não informado", 'error', null);
            return;
        }

        if (data.telefone == null || data.telefone.length == 0) {
            setLoading(false);
            showMessage("Aviso", "Telefone não informado", 'error', null);
            return;
        }

        if (data.password != '' || data.password.length > 0) {
            if (data.password.length < 5) {
                setLoading(false);
                showMessage("Aviso", "A senha precisa conter no mínimo 5 caracteres", 'error', null);
                return;
            }
            if (data.passwordRpt == null || data.passwordRpt == 0) {
                setLoading(false);
                showMessage("Aviso", "É necessário repetir a senha", 'error', null);
                return;
            } else if (data.passwordRpt != data.password) {
                setLoading(false);
                showMessage("Aviso", "As senhas não conferem", 'error', null);
                return;
            }
        }

        var itemAtualizado = JSON.parse(JSON.stringify(item));;

        itemAtualizado.email = data.email.length > 0 || data.email != '' ? data.email : item.email;
        itemAtualizado.senha = data.password.length > 0 || data.password != '' ? data.password : item.senha;

        if (item.segmentoProtocolo == 'Grande Gerador' || item.segmentoProtocolo == 'Gerador') {
            itemAtualizado.protocoloGerador[0].telefone = data.telefone.length > 0 || data.telefone != '' ? data.telefone : item.protocoloGerador[0].telefone;
            itemAtualizado.protocoloGerador[0].celular = data.celular.length > 0 || data.celular != '' ? data.celular : item.protocoloGerador[0].celular;
            controller = "protocoloGerador";
        }

        if (item.segmentoProtocolo == 'Transportador') {
            itemAtualizado.protocoloTransportador[0].telefone = data.telefone.length > 0 || data.telefone != '' ? data.telefone : item.protocoloTransportador[0].telefone;
            itemAtualizado.protocoloTransportador[0].celular = data.celular.length > 0 || data.celular != '' ? data.celular : item.protocoloTransportador[0].celular
            controller = "protocoloTransportador";
        }

        if (item.segmentoProtocolo == 'Destino Final') {
            itemAtualizado.protocoloDestino[0].telefone = data.telefone.length > 0 || data.telefone != '' ? data.telefone : item.protocoloDestino[0].telefone;
            itemAtualizado.protocoloDestino[0].celular = data.celular.length > 0 || data.celular != '' ? data.celular : item.protocoloDestino[0].celular
            controller = "protocoloDestino";
        }


        api_PUT(`${controller}/PutContatoProtocolo`, itemAtualizado)
            .then(result => {
                setLoading(false);
                history.push({
                    pathname: '/auth/MeuCadastro',
                })
                showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div className="content">
                {step == 0 &&
                    <>
                        <Card className={`card card-stats mt-4`}>
                            <CardBody>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <h4>Dados de Contato</h4>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <b><label><span className="text-danger"></span>Email</label></b>
                                                <Input type="email" name="email" defaultValue={loadDefaultValues("Email")} onBlur={handleEmail} innerRef={register({})} maxLength="200" autoComplete="off" />
                                                {errors.email && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                {errors.emailInvalido && <span className="form-control-label text-danger">E-mail Inválido</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <b><span className="text-danger"></span><label>Telefone</label></b>
                                                <InputTELEFONE type="text" name="telefone" defaultValue={loadDefaultValues("Telefone")} inputRef={register({})} />
                                                {errors.telefone && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <b><span className="text-danger"></span><label>Celular</label></b>
                                                <InputTELEFONE type="text" name="celular" defaultValue={loadDefaultValues("Celular")} inputRef={register({})} />
                                                {errors.telefone && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <h4>Senha de Acesso</h4>
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <b><label><span className="text-danger"></span>Nova Senha</label></b>
                                                <Input type="password" name="password" innerRef={register({})} maxLength="200" autoComplete="off" />
                                                {errors.password && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <b><label><span className="text-danger"></span>Repetir Senha</label></b>
                                                <Input type="password" name="passwordRpt" innerRef={register({})} maxLength="200" autoComplete="off" />
                                                {errors.password && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="12" className="text-center">
                                            <Button color="success" className="btn-mobile btn btn-success" type="submit"><i className="fas fa-save"></i> Salvar Alteração</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </>
                }
            </div>
        </>
    );
}